export default __webpack_public_path__ + "static/media/kundalini2.eed52555.PNG";